<template>
  <form @submit.prevent="submit">
    <div>
      <Field
        label="Large Logo"
        type="checkbox"
        @input="$v.resource.large_logo.touch()"
        @handleChange="handleChange"
        v-model="resource.large_logo"
        :error="large_logoError"
      />

      <div class="btn-save">
        <Btn :class="{'changes-made': changesMade}">Save Changes</Btn>
      </div>
    </div>
  </form>
</template>

<script>
import form from '@/mixins/form'

import Btn from '@/components/Btn'

import {errorMessages} from '@/lib/error_messages'

export default {
  name: 'SiteLogoForm',

  mixins: [form],

  components: {
    Btn
  },

  computed: {
    ...errorMessages(['logo_url', 'large_logo'])
  },

  validations: {
    resource: {
      logo_url: {},
      large_logo: {}
    }
  }
}
</script>
